import { createReducer, on } from '@ngrx/store';
import { createInitialPersonState } from './person.state';
import * as actions from './person.actions';

export const personReducer = createReducer(
    createInitialPersonState(),
    on(
        actions.setPerson,
        actions.setFolder,
        actions.setServices,
        actions.setServicesPublic,
        actions.setCurrentServiceId,
        (state, newState) => ({ ...state, ...newState }),
    ),
);
